import { ApplicationStep } from '@mkp/application/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const applicationPageActions = createActionGroup({
  source: 'Applications Page',
  events: {
    Opened: props<{ step: ApplicationStep; limit: number; offset: 0 }>(),
    'Load More Button Clicked': props<{
      step: ApplicationStep;
      limit: number;
      offset: number;
    }>(),
    'Load More Applications After Change': props<{
      step: ApplicationStep;
      limit: number;
      offset: number;
    }>(),
    'Load More Applications For Searched Application': props<{
      step: ApplicationStep;
      limit: number;
      offset: number;
    }>(),
    'Step Changed': props<{ step: ApplicationStep; limit: number; offset: 0 }>(),
    'Reload New Tab After Application Added': props<{
      step: ApplicationStep;
      limit: number;
      offset: 0;
    }>(),
    'User Select Application': props<{ applicationId: string }>(),
    'Select Application On Change': props<{
      applicationId: string | null | undefined;
      changedApplicationWasLast: boolean;
    }>(),
    'Application Refresh Status Changed': emptyProps(),
    'Searched Application Selected': props<{
      applicationId: string;
      step: ApplicationStep;
      limit: number;
      offset: number;
    }>(),
    'Query Params Updated': emptyProps(),
  },
});
